module.exports = __webpack_public_path__ + "img/er-4.0e65acb3.png";